export enum UserStatus {
  ARCHIVED = 'ARCHIVED',
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED',
}
// PO 2026-10-03 — the health, fitness-score and nutrition formulas exist only
// for male and female, so a profile holds one of the two or nothing.
export enum UserGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}
export enum UserOrderBy {
  CONNECTED_AT = 'CONNECTED_AT',
  MEMBERSHIP_RENEWAL = 'MEMBERSHIP_RENEWAL',
  NAME = 'NAME',
}
export enum UserToken {
  RESET_PASSWORD = 'RESET_PASSWORD',
  REGISTRATION = 'REGISTRATION',
  INVITE = 'INVITE',
  CONFIRM_CHANGED_EMAIL = 'CONFIRM_CHANGED_EMAIL',
  // Re-verifying an org's marketplace Terms of Use contact email after it's
  // edited — same link-click mechanic as CONFIRM_CHANGED_EMAIL, kept distinct
  // so the two confirm flows never collide on the same token row.
  TOU_CONTACT_EMAIL = 'TOU_CONTACT_EMAIL',
  // Same idea, but for a membership's OWN Terms of Use contact email — kept
  // distinct from TOU_CONTACT_EMAIL so the two confirm flows (org vs.
  // membership) never collide on the same token row either.
  MEMBERSHIP_TOU_CONTACT_EMAIL = 'MEMBERSHIP_TOU_CONTACT_EMAIL',
}

export enum OrganizationUserType {
  TRAINER = 'TRAINER',
  CLIENT = 'CLIENT',
  OWNER = 'OWNER',
  STAFF = 'STAFF',
}
